import { NewsTypeEnum } from 'APIPackage/NewsModule/enums/NewsTypeEnum';

export const mapNewsType = (type: NewsTypeEnum) => {
  const types = {
    NEWS: 'Новость',
    ANNOUNCEMENT: 'Анонс',
  };

  return types[type];
};
